import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
var _JsonPermission;
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import JsonPermissionCollection from "./JsonPermissionCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class JsonPermission extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [JsonPermission.id_attribute_name]: null,
      [JsonPermission.name_attribute_name]: null,
      [JsonPermission.children_attribute_name]: JsonPermissionCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return JsonPermission.id_attribute_name;
  }
  static getNameAttributeName() {
    return JsonPermission.name_attribute_name;
  }
  static getChildrenAttributeName() {
    return JsonPermission.children_attribute_name;
  }
  getId() {
    return this.getAttribute(JsonPermission.id_attribute_name);
  }
  getChildren() {
    return this.getAttribute(JsonPermission.children_attribute_name);
  }
  setChildren(children) {
    this.setAttribute(JsonPermission.children_attribute_name, children);
    return this;
  }
}
_JsonPermission = JsonPermission;
_defineProperty(JsonPermission, "SIDE_BAR_OVERVIEW", 'overview');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS", 'orders');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_IMPORT_ORDERS", 'import-orders');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EXPORT_ORDERS", 'export-orders');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_MULTIPLE_ORDER_STATUS_CHANGE", 'multiple-order-status-change');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_MULTIPLE_ORDER_CALL_STATUS_CHANGE", 'multiple-order-call-status-change');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_VIEW_ORDER_DETAILS", 'view-order-details');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS", 'edit-order-details');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_SEND_ORDER_TO_WAREHOUSE", 'send-order-to-warehouse');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ADD_ORDER_CALL_COMMENT", 'add-order-call-comment');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ADD_ORDER_PRIVATE_NOTE", 'add-order-private-note');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE", 'order-status-change');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_CONFIRM_ORDER", 'confirm-order');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_NO_ANSWER_ORDER", 'no-answer-order');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_CANCEL_ORDER", 'cancel-order');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_DELIVER_ORDER", 'deliver-order');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_RETURN_ORDER", 'return-order');
_defineProperty(JsonPermission, "SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_SHIP_ORDER", 'ship-order');
_defineProperty(JsonPermission, "SIDE_BAR_TESTED_ORDERS", 'tested-orders');
_defineProperty(JsonPermission, "SIDE_BAR_TESTED_ORDERS_SEND_TO_WAREHOUSE", 'send-to-warehouse');
_defineProperty(JsonPermission, "SIDE_BAR_TESTED_ORDERS_MULTIPLE_TEST_ORDER_STATUS_CHANGE", 'multiple-test-order-status-change');
_defineProperty(JsonPermission, "SIDE_BAR_TESTED_ORDERS_MULTIPLE_TEST_ORDER_CALL_STATUS_CHANGE", 'multiple-test-order-call-status-change');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_REQUEST", 'offer-request');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_REQUEST_CHANGE_CUSTOMER_DETAILS", 'change-customer-details');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_REQUEST_DELETE_OFFER_REQUEST", 'delete-offer-request');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_REQUEST_CHANGE_OFFER_REQUEST_STATUS", 'change-offer-request-status');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS", 'sale-reports');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_CHART", 'view-chart');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_AFFILIATE", 'view-stats-by-affiliate');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_REFERRER", 'view-stats-by-referrer');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_SALE_PAGE", 'view-stats-by-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_OFFER", 'view-stats-by-offer');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_COUNTRY", 'view-stats-by-country');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STAT_BY_WAREHOUSE", 'view-stats-by-warehouse');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_MANAGER", 'view-stats-by-manager');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_PRODUCT", 'view-stats-by-product');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_CALL_AGENT", 'view-stats-by-call-agent');
_defineProperty(JsonPermission, "SIDE_BAR_TRENDING", 'trending');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS", 'products');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_CREATE_PRODUCT", 'create-product');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_DUPLICATE_PRODUCT", 'duplicate-product');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_EDIT_PRODUCT", 'edit-product');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_DELETE_PRODUCT", 'delete-product');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_ADD_PRODUCT_INVENTORY", 'add-product-inventory');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_DELETE_PRODUCT_INVENTORY", 'delete-product-inventory');
_defineProperty(JsonPermission, "SIDE_BAR_PRODUCTS_VIEW_PRODUCT_DETAILS", 'view-product-details');
_defineProperty(JsonPermission, "SIDE_BAR_INVENTORY_OVERVIEW", 'inventory-overview');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER", 'offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER", 'cod-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_CREATE_OFFER", 'create-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_DUPLICATE_OFFER", 'duplicate-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_EDIT_OFFER", 'edit-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_DELETE_OFFER", 'delete-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_VIEW_OFFER_DETAILS", 'view-offer-details');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_GENERATE_OFFER_SALE_PAGE", 'generate-offer-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_COD_OFFER_GENERATE_OFFER_PRE_SALE_PAGE", 'generate-offer-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER", 'pre-paid-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_CREATE_OFFER", 'create-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_DUPLICATE_OFFER", 'duplicate-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_EDIT_OFFER", 'edit-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_DELETE_OFFER", 'delete-offer');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_VIEW_OFFER_DETAILS", 'view-offer-details');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_GENERATE_OFFER_SALE_PAGE", 'generate-offer-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_OFFER_PRE_PAID_OFFER_GENERATE_OFFER_PRE_SALE_PAGE", 'generate-offer-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_SALE_PAGE", 'sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE", 'original-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE", 'create-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_STATUS", 'edit-status');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_DOMAIN", 'edit-domain');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_OFFER", 'edit-offer');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_LANGUAGE", 'edit-language');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_GENERALE_DETAILS", 'edit-general-details');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_ADDONS", 'edit-addons');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_BLOCKS", 'edit-blocks');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_CHECKOUT_OPTIONS", 'edit-checkout-options');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_UPSELL_AND_CROSS_SELLS", 'edit-upsells-and-cross-sells');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE", 'edit-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_STATUS", 'edit-status');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_DOMAIN", 'edit-domain');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_OFFER", 'edit-offer');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_LANGUAGE", 'edit-language');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_GENERALE_DETAILS", 'edit-general-details');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_ADDONS", 'edit-addons');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_BLOCKS", 'edit-blocks');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_CHECKOUT_OPTIONS", 'edit-checkout-options');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_UPSELL_AND_CROSS_SELLS", 'edit-upsells-and-cross-sells');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_DUPLICATE_SALE_PAGE", 'duplicate-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_ORIGINAL_SALE_PAGE_DELETE_SALE_PAGE", 'delete-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE", 'generated-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE", 'create-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_STATUS", 'edit-status');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_DOMAIN", 'edit-domain');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_OFFER", 'edit-offer');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_LANGUAGE", 'edit-language');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_GENERALE_DETAILS", 'edit-general-details');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_ADDONS", 'edit-addons');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_BLOCKS", 'edit-blocks');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_CHECKOUT_OPTIONS", 'edit-checkout-options');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_UPSELL_AND_CROSS_SELLS", 'edit-upsells-and-cross-sells');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_DUPLICATE_SALE_PAGE", 'duplicate-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_GENERATED_SALE_PAGE_DELETE_SALE_PAGE", 'delete-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE", 'pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE", 'original-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE", 'create-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_STATUS", 'edit-status');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_DOMAIN", 'edit-domain');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_SALE_PAGE", 'edit-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_TITLE", 'edit-title');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_ADDONS", 'edit-addons');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_BLOCKS", 'edit-blocks');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_DUPLICATE", 'duplicate-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_STATUS", 'edit-status');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_DOMAIN", 'edit-domain');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_SALE_PAGE", 'edit-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_TITLE", 'edit-title');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_ADDONS", 'edit-addons');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_BLOCKS", 'edit-blocks');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_DELETE", 'delete-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE", 'generated-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_DUPLICATE", 'duplicate-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_STATUS", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_DOMAIN", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_SALE_PAGE", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_TITLE", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_ADDONS", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_PIXELS", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_BLOCKS", 'edit-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_DELETE", 'delete-pre-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_STORE_PAGES", 'store-pages');
_defineProperty(JsonPermission, "SIDE_BAR_STORE_PAGES_EDIT", 'edit-store-pages');
_defineProperty(JsonPermission, "SIDE_BAR_STORE_PAGES_EDIT_BLOCKS", 'blocks');
_defineProperty(JsonPermission, "SIDE_BAR_DOMAINS", 'domains');
_defineProperty(JsonPermission, "SIDE_BAR_DOMAINS_CREATE", 'create-domain');
_defineProperty(JsonPermission, "SIDE_BAR_DOMAINS_EDIT", 'edit-domain');
_defineProperty(JsonPermission, "SIDE_BAR_DOMAINS_DELETE", 'delete-domain');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS", 'business-managers');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE", 'woo-commerce');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_ADD_DOMAIN", 'add-domain');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_MAP_DOMAIN_OFFERS_WITH_WOO_COMMERCE_PRODUCTS", 'map-domain-offers-with-woo-commerce-products');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_MAP_DOMAIN_OFFERS_WITH_WOO_COMMERCE_PRODUCTS_SAVE", 'save-map-domain-offers-with-woo-commerce-products');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_CONNECT_DOMAIN_TO_WOO_COMMERCE", 'connect-domain-to-woo-commerce');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_DELETE_DOMAIN", 'delete-domain');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING", 'google-shopping');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_GENERATE_FEED", 'generate-feed');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_SAVE_DOMAIN_VERIFICATION_STRING", 'save-domain-verification-string');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_REFRESH_FEED_PRODUCTS", 'refresh-feed-products');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_DELETE_FEED", 'delete-feed');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_VIEW_FEED_DETAILS", 'view-feed-details');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_VIEW_FEED_DETAILS_SAVE", 'save-feed-details');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING", 'facebook-shopping');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_GENERATE_FEED", 'generate-feed');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_SAVE_DOMAIN_VERIFICATION_STRING", 'save-domain-verification-string');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_REFRESH_FEED_PRODUCTS", 'refresh-feed-products');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_DELETE_FEED", 'delete-feed');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_VIEW_FEED_DETAILS", 'view-feed-details');
_defineProperty(JsonPermission, "SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_VIEW_FEED_DETAILS_SAVE", 'save-feed-details');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS", 'settings');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_ACCOUNT_DETAILS", 'account-details');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS", 'payment-processors');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_ADD", 'add-payment-processor');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_EDIT", 'edit-payment-processor');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_DELETE", 'delete-payment-processor');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_ACTIVATE", 'activate-payment-processor');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_INFO", 'payment-info');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_PAYMENT_INFO_SAVE", 'save-payment-info');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_IDENTITY_VERIFICATION", 'identity-verification');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_IDENTITY_VERIFICATION_SAVE", 'save-identity-verification');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_TRACKING_DATA", 'tracking-data');
_defineProperty(JsonPermission, "SIDE_BAR_SETTINGS_TRACKING_DATA_SAVE", 'save-tracking-data');
_defineProperty(JsonPermission, "SIDE_BAR_INVOICES", 'invoices');
_defineProperty(JsonPermission, "SIDE_BAR_ELIGIBLE_ORDERS", 'eligible-orders');
_defineProperty(JsonPermission, "SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_PAYOUT", 'generate-payout');
_defineProperty(JsonPermission, "SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_REMITTANCE", 'generate-remittance');
_defineProperty(JsonPermission, "SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_EXPENSES", 'generate-expenses');
_defineProperty(JsonPermission, "SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_COMMISSIONS", 'generate-commissions');
_defineProperty(JsonPermission, "SIDE_BAR_PAYOUTS", 'payouts');
_defineProperty(JsonPermission, "SIDE_BAR_PAYOUTS_PAY_INVOICES", 'pay-invoices');
_defineProperty(JsonPermission, "SIDE_BAR_PAYOUTS_VIEW_DETAILS", 'view-details');
_defineProperty(JsonPermission, "SIDE_BAR_PAYOUTS_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE", 'delete-order-from-invoice');
_defineProperty(JsonPermission, "SIDE_BAR_PAYOUTS_VIEW_DETAILS_DOWNLOAD_AS_EXCEL", 'download-as-excel');
_defineProperty(JsonPermission, "SIDE_BAR_PAYOUTS_VIEW_DETAILS_DOWNLOAD_AS_PDF", 'download-as-pdf');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_REMITTANCE", 'warehouse-remittances');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_REMITTANCE_PAY_INVOICES", 'pay-invoices');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS", 'view-details');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE", 'delete-order-from-invoice');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS_DOWNLOAD_AS_EXCEL", 'download-as-excel');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS_DOWNLOAD_AS_PDF", 'download-as-pdf');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_EXPENSES", 'warehouse-expenses');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_EXPENSES_PAY_INVOICES", 'pay-invoices');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS", 'view-details');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE", 'delete-order-from-invoice');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS_DOWNLOAD_AS_EXCEL", 'download-as-excel');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS_DOWNLOAD_AS_PDF", 'download-as-pdf');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_COMMISSIONS", 'advertiser-commissions');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_COMMISSIONS_PAY_INVOICES", 'pay-invoices');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS", 'view-details');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE", 'delete-order-from-invoice');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS_DOWNLOAD_AS_EXCEL", 'download-as-excel');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS_DOWNLOAD_AS_PDF", 'download-as-pdf');
_defineProperty(JsonPermission, "SIDE_BAR_REFERRALS", 'referrals');
_defineProperty(JsonPermission, "SIDE_BAR_REFERRALS_GENERATE", 'referrals-generate');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING", 'accounting');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_CHART", 'view-chart');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_AFFILIATE", 'view-stats-by-affiliate');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_SELLER", 'view-stats-by-seller');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_REFERRER", 'view-stats-by-referrer');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_SALE_PAGE", 'view-stats-by-sale-page');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_OFFER", 'view-stats-by-offer');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_COUNTRY", 'view-stats-by-country');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_WAREHOUSE", 'view-stats-by-warehouse');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_MANAGER", 'view-stats-by-manager');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_PRODUCT", 'view-stats-by-product');
_defineProperty(JsonPermission, "SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_CALL_AGENT", 'view-stats-by-call-agent');
_defineProperty(JsonPermission, "SIDE_BAR_NOTIFICATIONS", 'notifications');
_defineProperty(JsonPermission, "SIDE_BAR_NOTIFICATIONS_CREATE", 'create');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS", 'tutorials');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_CREATE_TUTORIAL", 'create-tutorial');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_EDIT_TUTORIAL", 'edit-tutorial');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_DELETE_TUTORIAL", 'delete-tutorial');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_CREATE_TUTORIAL_CATEGORY", 'create-tutorial-category');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_EDIT_TUTORIAL_CATEGORY", 'edit-tutorial-category');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_DELETE_TUTORIAL_CATEGORY", 'delete-tutorial-category');
_defineProperty(JsonPermission, "SIDE_BAR_TUTORIALS_TOGGLE_PUBLISH_TUTORIAL_CATEGORY", 'toggle-publish-tutorial-category');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT", 'support');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS", 'faqs');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_CREATE_FAQ", 'create-faq');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_CREATE_FAQ_CREATE_CATEGORY", 'create-faq-create-category');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_EDIT_FAQ", 'edit-faq');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_EDIT_FAQ_CREATE_CATEGORY", 'edit-faq-create-category');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_DELETE_FAQ", 'delete-faq');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_DELETE_FAQ_CATEGORY", 'delete-faq-category');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_EDIT_FAQ_CATEGORY", 'edit-faq-category');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_FAQS_TOGGLE_FAQ_CATEGORY", 'toggle-faq-category');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_TICKETS", 'tickets');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_TICKETS_CREATE_TICKET", 'create-ticket');
_defineProperty(JsonPermission, "SIDE_BAR_SUPPORT_TICKETS_CREATE_TICKET_MESSAGE", 'create-ticket-message');
_defineProperty(JsonPermission, "SIDE_BAR_NETWORK_SDK_ACCOUNTS", 'network-sdk-accounts');
_defineProperty(JsonPermission, "SIDE_BAR_NETWORK_SDK_ACCOUNTS_CREATE", 'create-network-sdk-accounts');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSES", 'warehouses');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSES_CREATE_WAREHOUSE", 'create-warehouse');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSES_EDIT_WAREHOUSE", 'edit-warehouse');
_defineProperty(JsonPermission, "SIDE_BAR_WAREHOUSES_MULTIPLE_WAREHOUSE_ACTIVATION", 'multiple-warehouse-activation');
_defineProperty(JsonPermission, "SIDE_BAR_CALL_CENTER", 'call-center');
_defineProperty(JsonPermission, "SIDE_BAR_CALL_CENTER_CREATE_CALL_CENTER", 'create-call-center');
_defineProperty(JsonPermission, "SIDE_BAR_CALL_CENTER_EDIT_CALL_CENTER", 'edit-call-center');
_defineProperty(JsonPermission, "SIDE_BAR_CALL_CENTER_MULTIPLE_CALL_CENTER_ACTIVATION", 'multiple-call-center-activation');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER", 'advertiser');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_CREATE_ADVERTISER", 'create-advertiser');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_EDIT_ADVERTISER", 'edit-advertiser');
_defineProperty(JsonPermission, "SIDE_BAR_ADVERTISER_MULTIPLE_ADVERTISER_ACTIVATION", 'multiple-advertiser-activation');
_defineProperty(JsonPermission, "SIDE_BAR_AFFILIATES", 'affiliates');
_defineProperty(JsonPermission, "SIDE_BAR_AFFILIATES_MULTIPLE_AFFILIATE_ACTIVATION", 'multiple-affiliate-activation');
_defineProperty(JsonPermission, "SIDE_BAR_AFFILIATES_MULTIPLE_AFFILIATE_MANAGER_ASSIGNMENT", 'multiple-affiliate-manager-assignment');
_defineProperty(JsonPermission, "SIDE_BAR_REFERRALS_PROGRAM", 'referrals-program');
_defineProperty(JsonPermission, "SIDE_BAR_USERS", 'users');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS", 'user-accounts');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS", 'manage-users');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_CREATE_USER", 'create-user');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_EDIT_USER", 'edit-user');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_DUPLICATE_USER", 'duplicate-user');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_MULTIPLE_STATUS_CHANGE", 'duplicate-user');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_ROLES", 'manage-roles');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_ROLES_UPDATE_ROLES", 'update-roles');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_ACCOUNTS_MANAGE_ROLES_UPDATE_USERS", 'update-users');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_IDENTITY_VERIFICATION", 'identity-verification');
_defineProperty(JsonPermission, "SIDE_BAR_USERS_IDENTITY_VERIFICATION_ADD_IDENTITY_VERIFICATION", 'add-identity-verification');
_defineProperty(JsonPermission, "SIDE_BAR_LIBRARY", 'library');
_defineProperty(JsonPermission, "SIDE_BAR_ACTIVITY_LOGS", 'activity-logs');
_defineProperty(JsonPermission, "PERMISSIONS", {
  OVERVIEW: {
    ID: '0'
  },
  ORDERS: {
    ID: '1',
    IMPORT_ORDERS: {
      ID: '1.0'
    },
    EXPORT_ORDERS: {
      ID: '1.1'
    },
    MULTIPLE_ORDER_STATUS_CHANGE: {
      ID: '1.2'
    },
    MULTIPLE_ORDER_CALL_STATUS_CHANGE: {
      ID: '1.3'
    },
    VIEW_ORDER_DETAILS: {
      ID: '1.4',
      SEND_ORDER_TO_WAREHOUSE: {
        ID: '1.4.0'
      },
      ADD_ORDER_CALL_COMMENT: {
        ID: '1.4.1'
      },
      ADD_ORDER_PRIVATE_NOTE: {
        ID: '1.4.2'
      },
      ORDER_STATUS_CHANGE: {
        ID: '1.4.3',
        CONFIRM_ORDER: {
          ID: '1.4.3.0'
        },
        NO_ANSWER_ORDER: {
          ID: '1.4.3.1'
        },
        CANCEL_ORDER: {
          ID: '1.4.3.2'
        },
        DELIVER_ORDER: {
          ID: '1.4.3.3'
        },
        RETURN_ORDER: {
          ID: '1.4.3.4'
        },
        SHIP_ORDER: {
          ID: '1.4.3.5'
        }
      }
    }
  },
  TESTED_ORDERS: {
    ID: '2',
    SEND_TO_WAREHOUSE: {
      ID: '2.0'
    },
    MULTIPLE_TEST_ORDER_STATUS_CHANGE: {
      ID: '2.1'
    },
    MULTIPLE_TEST_ORDER_CALL_STATUS_CHANGE: {
      ID: '2.2'
    }
  },
  OFFER_REQUESTS: {
    ID: '3',
    CHANGE_CUSTOMER_DETAILS: {
      ID: '3.0'
    },
    DELETE_OFFER_REQUEST: {
      ID: '3.1'
    },
    CHANGE_OFFER_REQUEST_STATUS: {
      ID: '3.2'
    }
  },
  SALE_REPORTS: {
    ID: '4',
    VIEW_CHART: {
      ID: '4.0'
    },
    VIEW_STATS_BY_AFFILIATES: {
      ID: '4.1'
    },
    VIEW_STATS_BY_REFERRER: {
      ID: '4.2'
    },
    VIEW_STATS_BY_SALE_PAGE: {
      ID: '4.3'
    },
    VIEW_STATS_BY_OFFER: {
      ID: '4.4'
    },
    VIEW_STATS_BY_COUNTRY: {
      ID: '4.5'
    },
    VIEW_STATS_BY_WAREHOUSE: {
      ID: '4.6'
    },
    VIEW_STATS_BY_MANAGER: {
      ID: '4.7'
    },
    VIEW_STATS_BY_PRODUCT: {
      ID: '4.8'
    },
    VIEW_STATS_BY_CALL_AGENT: {
      ID: '4.9'
    }
  },
  TRENDING: {
    ID: '5'
  },
  PRODUCTS: {
    ID: '6',
    CREATE: {
      ID: '6.0'
    },
    DUPLICATE: {
      ID: '6.1'
    },
    EDIT: {
      ID: '6.2'
    },
    DELETE: {
      ID: '6.3'
    },
    ADD_INVENTORY: {
      ID: '6.4'
    },
    DELETE_INVENTORY: {
      ID: '6.5'
    },
    VIEW_DETAILS: {
      ID: '6.6'
    }
  },
  INVENTORY_OVERVIEW: {
    ID: '7'
  },
  OFFERS: {
    ID: '8',
    COD: {
      ID: '8.0',
      CREATE: {
        ID: '8.0.0'
      },
      DUPLICATE: {
        ID: '8.0.1'
      },
      EDIT: {
        ID: '8.0.2'
      },
      DELETE: {
        ID: '8.0.3'
      },
      VIEW_DETAILS: {
        ID: '8.0.4'
      },
      GENERATE_SALE_PAGE: {
        ID: '8.0.5'
      },
      GENERATE_PRE_SALE_PAGE: {
        ID: '8.0.6'
      }
    },
    PRE_PAID: {
      ID: '8.1',
      CREATE: {
        ID: '8.1.0'
      },
      DUPLICATE: {
        ID: '8.1.1'
      },
      EDIT: {
        ID: '8.1.2'
      },
      DELETE: {
        ID: '8.1.3'
      },
      VIEW_DETAILS: {
        ID: '8.1.4'
      },
      GENERATE_SALE_PAGE: {
        ID: '8.1.5'
      },
      GENERATE_PRE_SALE_PAGE: {
        ID: '8.1.6'
      }
    }
  },
  SALE_PAGES: {
    ID: '9',
    ORIGINAL: {
      ID: '9.0',
      CREATE: {
        ID: '9.0.0',
        STATUS: {
          ID: '9.0.0.0'
        },
        DOMAIN: {
          ID: '9.0.0.1'
        },
        OFFER: {
          ID: '9.0.0.2'
        },
        LANGUAGE: {
          ID: '9.0.0.3'
        },
        GENERALE_DETAILS: {
          ID: '9.0.0.4'
        },
        ADDONS: {
          ID: '9.0.0.5'
        },
        BLOCKS: {
          ID: '9.0.0.6'
        },
        CHECKOUT_OPTIONS: {
          ID: '9.0.0.7'
        },
        UPSELLS_AND_CROSS_SELLS: {
          ID: '9.0.0.8'
        }
      },
      EDIT: {
        ID: '9.0.1',
        STATUS: {
          ID: '9.0.1.0'
        },
        DOMAIN: {
          ID: '9.0.1.1'
        },
        OFFER: {
          ID: '9.0.1.2'
        },
        LANGUAGE: {
          ID: '9.0.1.3'
        },
        GENERALE_DETAILS: {
          ID: '9.0.1.4'
        },
        ADDONS: {
          ID: '9.0.1.5'
        },
        BLOCKS: {
          ID: '9.0.1.6'
        },
        CHECKOUT_OPTIONS: {
          ID: '9.0.1.7'
        },
        UPSELLS_AND_CROSS_SELLS: {
          ID: '9.0.1.8'
        }
      },
      DUPLICATE: {
        ID: '9.0.2'
      },
      DELETE: {
        ID: '9.0.3'
      }
    },
    GENERATED: {
      ID: '9.1',
      EDIT: {
        ID: '9.1.0',
        STATUS: {
          ID: '9.1.0.0'
        },
        DOMAIN: {
          ID: '9.1.0.1'
        },
        OFFER: {
          ID: '9.1.0.2'
        },
        LANGUAGE: {
          ID: '9.1.0.3'
        },
        GENERALE_DETAILS: {
          ID: '9.1.0.4'
        },
        ADDONS: {
          ID: '9.1.0.5'
        },
        BLOCKS: {
          ID: '9.1.0.6'
        },
        CHECKOUT_OPTIONS: {
          ID: '9.1.0.7'
        },
        UPSELLS_AND_CROSS_SELLS: {
          ID: '9.1.0.8'
        }
      },
      DUPLICATE: {
        ID: '9.1.1'
      },
      DELETE: {
        ID: '9.1.2'
      }
    }
  },
  PRE_SALE_PAGES: {
    ID: '10',
    ORIGINAL: {
      ID: '10.0',
      CREATE: {
        ID: '10.0.0',
        STATUS: {
          ID: '10.0.0.0'
        },
        DOMAIN: {
          ID: '10.0.0.1'
        },
        SALE_PAGE: {
          ID: '10.0.0.2'
        },
        TITLE: {
          ID: '10.0.0.3'
        },
        ADDONS: {
          ID: '10.0.0.4'
        },
        BLOCKS: {
          ID: '10.0.0.5'
        }
      },
      EDIT: {
        ID: '10.0.1',
        STATUS: {
          ID: '10.0.0.0'
        },
        DOMAIN: {
          ID: '10.0.0.1'
        },
        SALE_PAGE: {
          ID: '10.0.0.2'
        },
        TITLE: {
          ID: '10.0.0.3'
        },
        ADDONS: {
          ID: '10.0.0.4'
        },
        BLOCKS: {
          ID: '10.0.0.5'
        }
      },
      DELETE: {
        ID: '10.0.2'
      },
      DUPLICATE: {
        ID: '10.0.3'
      }
    },
    GENERATED: {
      ID: '10.1',
      EDIT: {
        ID: '10.1.0',
        STATUS: {
          ID: '10.1.0.0'
        },
        DOMAIN: {
          ID: '10.1.0.1'
        },
        SALE_PAGE: {
          ID: '10.1.0.2'
        },
        TITLE: {
          ID: '10.1.0.3'
        },
        ADDONS: {
          ID: '10.1.0.4'
        },
        BLOCKS: {
          ID: '10.1.0.5'
        }
      },
      DELETE: {
        ID: '10.1.1'
      },
      DUPLICATE: {
        ID: '10.1.2'
      }
    }
  },
  STORE_PAGES: {
    ID: '11',
    EDIT: {
      ID: '11.0',
      BLOCKS: {
        ID: '11.0.0'
      }
    }
  },
  DOMAINS: {
    ID: '12',
    CREATE: {
      ID: '12.0'
    },
    EDIT: {
      ID: '12.1'
    },
    DELETE: {
      ID: '12.2'
    }
  },
  BUSINESS_MANAGERS: {
    ID: '13',
    WOO_COMMERCE: {
      ID: '13.0',
      ADD_DOMAIN: {
        ID: '13.0.0'
      },
      MAP_DOMAIN_OFFERS_WITH_WOO_COMMERCE_PRODUCTS: {
        ID: '13.0.1',
        SAVE: {
          ID: '13.0.1.0'
        }
      },
      CONNECT_DOMAIN_TO_WOO_COMMERCE: {
        ID: '13.0.2'
      },
      DELETE_DOMAIN: {
        ID: '13.0.3'
      }
    },
    GOOGLE_SHOPPING: {
      ID: '13.1',
      GENERATE_FEED: {
        ID: '13.1.0'
      },
      SAVE_DOMAIN_VERIFICATION_STRING: {
        ID: '13.1.1'
      },
      REFRESH_FEED_PRODUCTS: {
        ID: '13.1.2'
      },
      DELETE_FEED: {
        ID: '13.1.3'
      },
      VIEW_FEED_DETAILS: {
        ID: '13.1.4',
        SAVE: {
          ID: '13.1.4.0'
        }
      }
    },
    FACEBOOK_SHOPPING: {
      ID: '13.2',
      GENERATE_FEED: {
        ID: '13.2.0'
      },
      SAVE_DOMAIN_VERIFICATION_STRING: {
        ID: '13.2.1'
      },
      REFRESH_FEED_PRODUCTS: {
        ID: '13.2.2'
      },
      DELETE_FEED: {
        ID: '13.2.3'
      },
      VIEW_FEED_DETAILS: {
        ID: '13.2.4',
        SAVE: {
          ID: '13.2.4.0'
        }
      }
    }
  },
  SETTINGS: {
    ID: '14',
    ACCOUNT_DETAILS: {
      ID: '14.0'
    },
    PAYMENT_PROCESSORS: {
      ID: '14.1',
      ADD: {
        ID: '14.1.0'
      },
      EDIT: {
        ID: '14.1.1'
      },
      DELETE: {
        ID: '14.1.2'
      },
      ACTIVATE: {
        ID: '14.1.3'
      }
    },
    PAYMENT_INFO: {
      ID: '14.2',
      SAVE: {
        ID: '14.2.0'
      }
    },
    IDENTITY_VERIFICATION: {
      ID: '14.3'
    },
    TRACKING_DATA: {
      ID: '14.4',
      SAVE: {
        ID: '14.4.0'
      }
    }
  },
  INVOICES: {
    ID: '15',
    ELIGIBLE_ORDERS: {
      ID: '15.0',
      GENERATE_PAYOUT: {
        ID: '15.0.0'
      },
      GENERATE_REMITTANCE: {
        ID: '15.0.1'
      },
      GENERATE_EXPENSES: {
        ID: '15.0.2'
      },
      GENERATE_COMMISSIONS: {
        ID: '15.0.3'
      }
    },
    PAYOUTS: {
      ID: '15.1',
      PAY: {
        ID: '15.1.0'
      },
      VIEW_DETAILS: {
        ID: '15.1.1',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '5.1.1.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '5.1.1.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '5.1.1.2'
        }
      }
    },
    REMITTANCE: {
      ID: '15.2',
      PAY: {
        ID: '15.2.0'
      },
      VIEW_DETAILS: {
        ID: '15.2.1',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '5.2.1.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '5.2.1.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '5.2.1.2'
        }
      }
    },
    EXPENSES: {
      ID: '15.3',
      PAY: {
        ID: '15.3.0'
      },
      VIEW_DETAILS: {
        ID: '15.3.1',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '5.3.1.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '5.3.1.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '5.3.1.2'
        }
      }
    },
    ADVERTISER_COMMISSION: {
      ID: '15.4',
      VIEW_DETAILS: {
        ID: '15.4.0',
        DELETE_ORDER_FROM_INVOICE: {
          ID: '15.4.0.0'
        },
        DOWNLOAD_AS_EXCEL: {
          ID: '15.4.0.1'
        },
        DOWNLOAD_AS_PDF: {
          ID: '15.4.0.2'
        }
      }
    },
    REFERRALS: {
      ID: '15.5',
      VIEW_DETAILS: {
        ID: '15.5.0'
      }
    }
  },
  ACCOUNTING: {
    ID: '16',
    VIEW_CHART: {
      ID: '16.0'
    },
    VIEW_STATS_BY_AFFILIATES: {
      ID: '16.1'
    },
    VIEW_STATS_BY_REFERRER: {
      ID: '16.2'
    },
    VIEW_STATS_BY_SALE_PAGE: {
      ID: '16.3'
    },
    VIEW_STATS_BY_OFFER: {
      ID: '16.4'
    },
    VIEW_STATS_BY_COUNTRY: {
      ID: '16.5'
    },
    VIEW_STATS_BY_WAREHOUSE: {
      ID: '16.6'
    },
    VIEW_STATS_BY_MANAGER: {
      ID: '16.7'
    },
    VIEW_STATS_BY_PRODUCT: {
      ID: '16.8'
    },
    VIEW_STATS_BY_CALL_AGENT: {
      ID: '16.9'
    }
  },
  NOTIFICATIONS: {
    ID: '17',
    CREATE: {
      ID: '17.0'
    }
  },
  TUTORIALS: {
    ID: '18',
    CREATE: {
      ID: '18.0',
      CREATE_CATEGORY: {
        ID: '18.0.0'
      }
    },
    EDIT: {
      ID: '18.1',
      CREATE_CATEGORY: {
        ID: '18.1.0'
      }
    },
    DELETE: {
      ID: '18.2'
    },
    TOGGLE_PUBLISH_CATEGORY: {
      ID: '18.3'
    },
    EDIT_CATEGORY: {
      ID: '18.4'
    },
    DELETE_CATEGORY: {
      ID: '18.5'
    }
  },
  SUPPORT: {
    ID: '19',
    FAQS: {
      ID: '19.0',
      CREATE: {
        ID: '19.0.0',
        CREATE_CATEGORY: {
          ID: '19.0.0.0'
        }
      },
      EDIT: {
        ID: '19.0.1',
        CREATE_CATEGORY: {
          ID: '19.0.1.0'
        }
      },
      DELETE: '19.0.2',
      DELETE_FAQ_CATEGORY: '19.0.3',
      EDIT_FAQ_CATEGORY: '19.0.4',
      TOGGLE_FAQ_CATEGORY: '19.0.5'
    },
    TICKETS: {
      ID: '19.1',
      CREATE: {
        ID: '19.1.0'
      },
      CREATE_TICKET_MESSAGE: {
        ID: '19.1.1'
      }
    }
  },
  NETWORK_SDK_ACCOUNTS: {
    ID: '20',
    CREATE: {
      ID: '20.0'
    }
  },
  WAREHOUSES: {
    ID: '21',
    CREATE: {
      ID: '21.0'
    },
    EDIT: {
      ID: '21.1'
    },
    MULTIPLE_WAREHOUSE_ACTIVATION: {
      ID: '21.2'
    }
  },
  CALL_CENTERS: {
    ID: '22',
    CREATE: {
      ID: '22.0'
    },
    EDIT: {
      ID: '22.1'
    },
    MULTIPLE_CALL_CENTER_ACTIVATION: {
      ID: '22.2'
    }
  },
  ADVERTISERS: {
    ID: '23',
    CREATE: {
      ID: '23.0'
    },
    EDIT: {
      ID: '23.1'
    },
    MULTIPLE_ADVERTISER_ACTIVATION: {
      ID: '23.2'
    }
  },
  AFFILIATES: {
    ID: '24',
    MULTIPLE_ACTIVATION: {
      ID: '24.0'
    },
    MULTIPLE_AFFILIATE_MANAGER_ASSIGNMENT: {
      ID: '24.1'
    }
  },
  REFERRALS_PROGRAM: {
    ID: '25'
  },
  USERS: {
    ID: '26',
    USER_ACCOUNTS: {
      ID: '26.0',
      MANAGE_USERS: {
        ID: '26.0.0',
        CREATE_USER: {
          ID: '26.0.0.0'
        },
        EDIT_USER: {
          ID: '26.0.0.1'
        },
        MULTIPLE_STATUS_CHANGE: {
          ID: '26.0.0.2'
        }
      },
      MANAGE_ROLES: {
        ID: '26.0.1',
        ADD_PERMISSIONS_TO_ROLE: {
          ID: '26.0.1.0'
        },
        REMOVE_PERMISSION_FROM_ROLE: {
          ID: '26.0.1.1'
        },
        ADD_PERMISSIONS_TO_USER: {
          ID: '26.0.1.2'
        },
        REMOVE_PERMISSION_FROM_USER: {
          ID: '26.0.1.3'
        }
      },
      MANAGE_PLAN: {
        ID: '26.0.2',
        UPDATE_PLAN_PERMISSIONS: {
          ID: '26.0.2.0'
        }
      }
    },
    IDENTITY_VERIFICATION: {
      ID: '26.1',
      VERIFY_IDENTITY_VERIFICATION: {
        ID: '26.1.0'
      }
    }
  },
  LIBRARY: {
    ID: '27'
  },
  ACTIVITY_LOGS: {
    ID: '28'
  },
  PRODUCT_SALE_PAGES: {
    ID: '29',
    CREATE: {
      ID: '29.0',
      STATUS: {
        ID: '29.0.0'
      },
      DOMAIN: {
        ID: '29.0.1'
      },
      PRODUCT: {
        ID: '29.0.2'
      },
      LANGUAGE: {
        ID: '29.0.3'
      },
      GENERALE_DETAILS: {
        ID: '29.0.4'
      },
      ADDONS: {
        ID: '29.0.5'
      },
      BLOCKS: {
        ID: '29.0.6'
      },
      CHECKOUT_OPTIONS: {
        ID: '29.0.7'
      },
      UPSELLS_AND_CROSS_SELLS: {
        ID: '29.0.8'
      }
    },
    EDIT: {
      ID: '29.1',
      STATUS: {
        ID: '29.1.0'
      },
      DOMAIN: {
        ID: '29.1.1'
      },
      OFFER: {
        ID: '29.1.2'
      },
      PRODUCT: {
        ID: '29.1.3'
      },
      LANGUAGE: {
        ID: '29.1.4'
      },
      GENERALE_DETAILS: {
        ID: '29.1.5'
      },
      ADDONS: {
        ID: '29.1.6'
      },
      BLOCKS: {
        ID: '29.1.7'
      },
      CHECKOUT_OPTIONS: {
        ID: '29.1.8'
      },
      UPSELLS_AND_CROSS_SELLS: {
        ID: '29.1.9'
      }
    },
    DUPLICATE: {
      ID: '29.0.2'
    },
    DELETE: {
      ID: '29.0.3'
    }
  }
});
_defineProperty(JsonPermission, "DEFAULT_PERMISSIONS", [{
  id: _JsonPermission.PERMISSIONS.OVERVIEW.ID,
  name: _JsonPermission.SIDE_BAR_OVERVIEW,
  children: []
}, {
  id: _JsonPermission.PERMISSIONS.ORDERS.ID,
  name: _JsonPermission.SIDE_BAR_ORDERS,
  children: [{
    id: _JsonPermission.PERMISSIONS.ORDERS.IMPORT_ORDERS.ID,
    name: _JsonPermission.SIDE_BAR_ORDERS_IMPORT_ORDERS,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.ORDERS.EXPORT_ORDERS.ID,
    name: _JsonPermission.SIDE_BAR_ORDERS_EXPORT_ORDERS,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.ORDERS.MULTIPLE_ORDER_STATUS_CHANGE.ID,
    name: _JsonPermission.SIDE_BAR_ORDERS_MULTIPLE_ORDER_STATUS_CHANGE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.ORDERS.MULTIPLE_ORDER_CALL_STATUS_CHANGE.ID,
    name: _JsonPermission.SIDE_BAR_ORDERS_MULTIPLE_ORDER_CALL_STATUS_CHANGE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ID,
    name: _JsonPermission.SIDE_BAR_ORDERS_VIEW_ORDER_DETAILS,
    children: [{
      id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.SEND_ORDER_TO_WAREHOUSE.ID,
      name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_SEND_ORDER_TO_WAREHOUSE,
      children: []
    }, {
      id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ADD_ORDER_CALL_COMMENT.ID,
      name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ADD_ORDER_CALL_COMMENT,
      children: []
    }, {
      id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ADD_ORDER_PRIVATE_NOTE.ID,
      name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ADD_ORDER_PRIVATE_NOTE,
      children: []
    }, {
      id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.ID,
      name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE,
      children: [{
        id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.CONFIRM_ORDER.ID,
        name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_CONFIRM_ORDER,
        children: []
      }, {
        id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.NO_ANSWER_ORDER.ID,
        name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_NO_ANSWER_ORDER,
        children: []
      }, {
        id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.CANCEL_ORDER.ID,
        name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_CANCEL_ORDER,
        children: []
      }, {
        id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.DELIVER_ORDER.ID,
        name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_DELIVER_ORDER,
        children: []
      }, {
        id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.RETURN_ORDER.ID,
        name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_RETURN_ORDER,
        children: []
      }, {
        id: _JsonPermission.PERMISSIONS.ORDERS.VIEW_ORDER_DETAILS.ORDER_STATUS_CHANGE.SHIP_ORDER.ID,
        name: _JsonPermission.SIDE_BAR_ORDERS_EDIT_ORDER_DETAILS_ORDER_STATUS_CHANGE_SHIP_ORDER,
        children: []
      }]
    }]
  }]
}, {
  id: _JsonPermission.PERMISSIONS.TESTED_ORDERS.ID,
  name: _JsonPermission.SIDE_BAR_TESTED_ORDERS,
  children: [{
    id: _JsonPermission.PERMISSIONS.TESTED_ORDERS.SEND_TO_WAREHOUSE.ID,
    name: _JsonPermission.SIDE_BAR_TESTED_ORDERS_SEND_TO_WAREHOUSE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.TESTED_ORDERS.MULTIPLE_TEST_ORDER_STATUS_CHANGE.ID,
    name: _JsonPermission.SIDE_BAR_TESTED_ORDERS_MULTIPLE_TEST_ORDER_STATUS_CHANGE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.TESTED_ORDERS.MULTIPLE_TEST_ORDER_CALL_STATUS_CHANGE.ID,
    name: _JsonPermission.SIDE_BAR_TESTED_ORDERS_MULTIPLE_TEST_ORDER_CALL_STATUS_CHANGE,
    children: []
  }]
}, {
  id: _JsonPermission.PERMISSIONS.OFFER_REQUESTS.ID,
  name: _JsonPermission.SIDE_BAR_OFFER_REQUEST,
  children: [{
    id: _JsonPermission.PERMISSIONS.OFFER_REQUESTS.CHANGE_CUSTOMER_DETAILS.ID,
    name: _JsonPermission.SIDE_BAR_OFFER_REQUEST_CHANGE_CUSTOMER_DETAILS,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.OFFER_REQUESTS.DELETE_OFFER_REQUEST.ID,
    name: _JsonPermission.SIDE_BAR_OFFER_REQUEST_DELETE_OFFER_REQUEST,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.OFFER_REQUESTS.CHANGE_OFFER_REQUEST_STATUS.ID,
    name: _JsonPermission.SIDE_BAR_OFFER_REQUEST_CHANGE_OFFER_REQUEST_STATUS,
    children: []
  }]
}, {
  id: _JsonPermission.PERMISSIONS.SALE_REPORTS.ID,
  name: _JsonPermission.SIDE_BAR_SALE_REPORTS,
  children: [{
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_CHART.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_CHART,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_AFFILIATES.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_AFFILIATE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_REFERRER.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_REFERRER,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_SALE_PAGE.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_SALE_PAGE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_OFFER.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_OFFER,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_COUNTRY.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_COUNTRY,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_WAREHOUSE.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STAT_BY_WAREHOUSE,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_MANAGER.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_MANAGER,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_PRODUCT.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_PRODUCT,
    children: []
  }, {
    id: _JsonPermission.PERMISSIONS.SALE_REPORTS.VIEW_STATS_BY_CALL_AGENT.ID,
    name: _JsonPermission.SIDE_BAR_SALE_REPORTS_VIEW_STATS_BY_CALL_AGENT,
    children: []
  }]
}, {
  id: _JsonPermission.PERMISSIONS.TRENDING.ID,
  name: _JsonPermission.SIDE_BAR_TRENDING,
  children: []
}, {
  id: '6',
  name: _JsonPermission.SIDE_BAR_PRODUCTS,
  children: [{
    id: '6.0',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_CREATE_PRODUCT,
    children: []
  }, {
    id: '6.1',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_DUPLICATE_PRODUCT,
    children: []
  }, {
    id: '6.2',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_EDIT_PRODUCT,
    children: []
  }, {
    id: '6.3',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_DELETE_PRODUCT,
    children: []
  }, {
    id: '6.4',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_ADD_PRODUCT_INVENTORY,
    children: []
  }, {
    id: '6.5',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_DELETE_PRODUCT_INVENTORY,
    children: []
  }, {
    id: '6.6',
    name: _JsonPermission.SIDE_BAR_PRODUCTS_VIEW_PRODUCT_DETAILS,
    children: []
  }]
}, {
  id: '7',
  name: _JsonPermission.SIDE_BAR_INVENTORY_OVERVIEW,
  children: []
}, {
  id: '8',
  name: _JsonPermission.SIDE_BAR_OFFER,
  children: [{
    id: '8.0',
    name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER,
    children: [{
      id: '8.0.0',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_CREATE_OFFER,
      children: []
    }, {
      id: '8.0.1',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_DUPLICATE_OFFER,
      children: []
    }, {
      id: '8.0.2',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_EDIT_OFFER,
      children: []
    }, {
      id: '8.0.3',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_DELETE_OFFER,
      children: []
    }, {
      id: '8.0.4',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_VIEW_OFFER_DETAILS,
      children: []
    }, {
      id: '8.0.5',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_GENERATE_OFFER_SALE_PAGE,
      children: []
    }, {
      id: '8.0.6',
      name: _JsonPermission.SIDE_BAR_OFFER_COD_OFFER_GENERATE_OFFER_PRE_SALE_PAGE,
      children: []
    }]
  }, {
    id: '8.1',
    name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER,
    children: [{
      id: '8.1.0',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_CREATE_OFFER,
      children: []
    }, {
      id: '8.1.1',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_DUPLICATE_OFFER,
      children: []
    }, {
      id: '8.1.2',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_EDIT_OFFER,
      children: []
    }, {
      id: '8.1.3',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_DELETE_OFFER,
      children: []
    }, {
      id: '8.1.4',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_VIEW_OFFER_DETAILS,
      children: []
    }, {
      id: '8.1.5',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_GENERATE_OFFER_SALE_PAGE,
      children: []
    }, {
      id: '8.1.6',
      name: _JsonPermission.SIDE_BAR_OFFER_PRE_PAID_OFFER_GENERATE_OFFER_PRE_SALE_PAGE,
      children: []
    }]
  }]
}, {
  id: '9',
  name: _JsonPermission.SIDE_BAR_SALE_PAGE,
  children: [{
    id: '9.0',
    name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE,
    children: [{
      id: '9.0.0',
      name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE,
      children: [{
        id: '9.0.0.0',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_STATUS,
        children: []
      }, {
        id: '9.0.0.1',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_DOMAIN,
        children: []
      }, {
        id: '9.0.0.2',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_OFFER,
        children: []
      }, {
        id: '9.0.0.3',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_LANGUAGE,
        children: []
      }, {
        id: '9.0.0.4',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_GENERALE_DETAILS,
        children: []
      }, {
        id: '9.0.0.5',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_ADDONS,
        children: []
      }, {
        id: '9.0.0.6',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_BLOCKS,
        children: []
      }, {
        id: '9.0.0.7',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_CHECKOUT_OPTIONS,
        children: []
      }, {
        id: '9.0.0.8',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_CREATE_SALE_PAGE_EDIT_UPSELL_AND_CROSS_SELLS,
        children: []
      }]
    }, {
      id: '9.0.1',
      name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE,
      children: [{
        id: '9.0.1.0',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_STATUS,
        children: []
      }, {
        id: '9.0.1.1',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_DOMAIN,
        children: []
      }, {
        id: '9.0.1.2',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_OFFER,
        children: []
      }, {
        id: '9.0.1.3',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_LANGUAGE,
        children: []
      }, {
        id: '9.0.1.4',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_GENERALE_DETAILS,
        children: []
      }, {
        id: '9.0.1.5',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_ADDONS,
        children: []
      }, {
        id: '9.0.1.6',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_BLOCKS,
        children: []
      }, {
        id: '9.0.1.7',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_CHECKOUT_OPTIONS,
        children: []
      }, {
        id: '9.0.1.8',
        name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_EDIT_SALE_PAGE_EDIT_UPSELL_AND_CROSS_SELLS,
        children: []
      }]
    }, {
      id: '9.0.2',
      name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_DUPLICATE_SALE_PAGE,
      children: []
    }, {
      id: '9.0.3',
      name: _JsonPermission.SIDE_BAR_ORIGINAL_SALE_PAGE_DELETE_SALE_PAGE,
      children: []
    }]
  }, {
    id: '9.1',
    name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE,
    children: [{
      id: '9.1.0',
      name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE,
      children: [{
        id: '9.1.0.0',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_STATUS,
        children: []
      }, {
        id: '9.1.0.1',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_DOMAIN,
        children: []
      }, {
        id: '9.1.0.2',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_OFFER,
        children: []
      }, {
        id: '9.1.0.3',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_LANGUAGE,
        children: []
      }, {
        id: '9.1.0.4',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_GENERALE_DETAILS,
        children: []
      }, {
        id: '9.1.0.5',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_ADDONS,
        children: []
      }, {
        id: '9.1.0.6',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_BLOCKS,
        children: []
      }, {
        id: '9.1.0.7',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_CHECKOUT_OPTIONS,
        children: []
      }, {
        id: '9.1.0.8',
        name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_EDIT_SALE_PAGE_EDIT_UPSELL_AND_CROSS_SELLS,
        children: []
      }]
    }, {
      id: '9.1.1',
      name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_DUPLICATE_SALE_PAGE,
      children: []
    }, {
      id: '9.1.2',
      name: _JsonPermission.SIDE_BAR_GENERATED_SALE_PAGE_DELETE_SALE_PAGE,
      children: []
    }]
  }]
}, {
  id: '10',
  name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE,
  children: [{
    id: '10.0',
    name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE,
    children: [{
      id: '10.0.0',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE,
      children: []
    }, {
      id: '10.0.1',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_STATUS,
      children: []
    }, {
      id: '10.0.2',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_DOMAIN,
      children: []
    }, {
      id: '10.0.3',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_SALE_PAGE,
      children: []
    }, {
      id: '10.0.4',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_TITLE,
      children: []
    }, {
      id: '10.0.5',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_ADDONS,
      children: []
    }, {
      id: '10.0.6',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_CREATE_EDIT_BLOCKS,
      children: []
    }, {
      id: '10.0.7',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_DUPLICATE,
      children: []
    }, {
      id: '10.0.8',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT,
      children: []
    }, {
      id: '10.0.9',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_STATUS,
      children: []
    }, {
      id: '10.0.10',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_DOMAIN,
      children: []
    }, {
      id: '10.0.11',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_SALE_PAGE,
      children: []
    }, {
      id: '10.0.12',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_TITLE,
      children: []
    }, {
      id: '10.0.13',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_ADDONS,
      children: []
    }, {
      id: '10.0.14',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_EDIT_BLOCKS,
      children: []
    }, {
      id: '10.0.15',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_ORIGINAL_PRE_SALE_PAGE_DELETE,
      children: []
    }]
  }, {
    id: '10.1',
    name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE,
    children: [{
      id: '10.1.0',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_DUPLICATE,
      children: []
    }, {
      id: '10.1.1',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT,
      children: []
    }, {
      id: '10.1.2',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_STATUS,
      children: []
    }, {
      id: '10.1.3',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_DOMAIN,
      children: []
    }, {
      id: '10.1.4',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_SALE_PAGE,
      children: []
    }, {
      id: '10.1.5',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_TITLE,
      children: []
    }, {
      id: '10.1.6',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_ADDONS,
      children: []
    }, {
      id: '10.1.7',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_PIXELS,
      children: []
    }, {
      id: '10.1.8',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_EDIT_BLOCKS,
      children: []
    }, {
      id: '10.1.9',
      name: _JsonPermission.SIDE_BAR_PRE_SALE_PAGE_GENERATED_PRE_SALE_PAGE_DELETE,
      children: []
    }]
  }]
}, {
  id: '11',
  name: _JsonPermission.SIDE_BAR_STORE_PAGES,
  children: [{
    id: '11.0',
    name: _JsonPermission.SIDE_BAR_STORE_PAGES_EDIT,
    children: [{
      id: '11.0.0',
      name: _JsonPermission.SIDE_BAR_STORE_PAGES_EDIT_BLOCKS,
      children: []
    }]
  }]
}, {
  id: '12',
  name: _JsonPermission.SIDE_BAR_DOMAINS,
  children: [{
    id: '12.0',
    name: _JsonPermission.SIDE_BAR_DOMAINS_CREATE,
    children: []
  }, {
    id: '12.1',
    name: _JsonPermission.SIDE_BAR_DOMAINS_EDIT,
    children: []
  }, {
    id: '12.2',
    name: _JsonPermission.SIDE_BAR_DOMAINS_DELETE,
    children: []
  }]
}, {
  id: '13',
  name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS,
  children: [{
    id: '13.0',
    name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE,
    children: [{
      id: '13.0.0',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_ADD_DOMAIN,
      children: []
    }, {
      id: '13.0.1',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_MAP_DOMAIN_OFFERS_WITH_WOO_COMMERCE_PRODUCTS,
      children: [{
        id: '13.0.1.0',
        name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_MAP_DOMAIN_OFFERS_WITH_WOO_COMMERCE_PRODUCTS_SAVE,
        children: []
      }]
    }, {
      id: '13.0.2',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_CONNECT_DOMAIN_TO_WOO_COMMERCE,
      children: []
    }, {
      id: '13.0.3',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_WOO_COMMERCE_DELETE_DOMAIN,
      children: []
    }]
  }, {
    id: '13.1',
    name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING,
    children: [{
      id: '13.1.0',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_GENERATE_FEED,
      children: []
    }, {
      id: '13.1.1',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_SAVE_DOMAIN_VERIFICATION_STRING,
      children: []
    }, {
      id: '13.1.2',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_REFRESH_FEED_PRODUCTS,
      children: []
    }, {
      id: '13.1.3',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_DELETE_FEED,
      children: []
    }, {
      id: '13.1.4',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_VIEW_FEED_DETAILS,
      children: [{
        id: '13.1.4.0',
        name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_GOOGLE_SHOPPING_VIEW_FEED_DETAILS_SAVE,
        children: []
      }]
    }]
  }, {
    id: '13.2',
    name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING,
    children: [{
      id: '13.2.0',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_GENERATE_FEED,
      children: []
    }, {
      id: '13.2.1',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_SAVE_DOMAIN_VERIFICATION_STRING,
      children: []
    }, {
      id: '13.2.2',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_REFRESH_FEED_PRODUCTS,
      children: []
    }, {
      id: '13.2.3',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_DELETE_FEED,
      children: []
    }, {
      id: '13.2.4',
      name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_VIEW_FEED_DETAILS,
      children: [{
        id: '13.2.4.0',
        name: _JsonPermission.SIDE_BAR_BUSINESS_MANAGERS_FACEBOOK_SHOPPING_VIEW_FEED_DETAILS_SAVE,
        children: []
      }]
    }]
  }]
}, {
  id: '14',
  name: _JsonPermission.SIDE_BAR_SETTINGS,
  children: [{
    id: '14.0',
    name: _JsonPermission.SIDE_BAR_SETTINGS_ACCOUNT_DETAILS,
    children: []
  }, {
    id: '14.1',
    name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS,
    children: [{
      id: '14.1.0',
      name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_ADD,
      children: []
    }, {
      id: '14.1.1',
      name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_EDIT,
      children: []
    }, {
      id: '14.1.2',
      name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_DELETE,
      children: []
    }, {
      id: '14.1.3',
      name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_PROCESSORS_ACTIVATE,
      children: []
    }]
  }, {
    id: '14.2',
    name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_INFO,
    children: [{
      id: '14.2.0',
      name: _JsonPermission.SIDE_BAR_SETTINGS_PAYMENT_INFO_SAVE,
      children: []
    }]
  }, {
    id: '14.3',
    name: _JsonPermission.SIDE_BAR_SETTINGS_IDENTITY_VERIFICATION,
    children: [{
      id: '14.3.0',
      name: _JsonPermission.SIDE_BAR_SETTINGS_IDENTITY_VERIFICATION_SAVE,
      children: []
    }]
  }, {
    id: '14.4',
    name: _JsonPermission.SIDE_BAR_SETTINGS_TRACKING_DATA,
    children: [{
      id: '14.4.0',
      name: _JsonPermission.SIDE_BAR_SETTINGS_TRACKING_DATA_SAVE,
      children: []
    }]
  }]
}, {
  id: '15',
  name: _JsonPermission.SIDE_BAR_INVOICES,
  children: [{
    id: '15.0',
    name: _JsonPermission.SIDE_BAR_ELIGIBLE_ORDERS,
    children: [{
      id: '15.0.0',
      name: _JsonPermission.SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_PAYOUT,
      children: []
    }, {
      id: '15.0.1',
      name: _JsonPermission.SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_REMITTANCE,
      children: []
    }, {
      id: '15.0.2',
      name: _JsonPermission.SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_EXPENSES,
      children: []
    }, {
      id: '15.0.3',
      name: _JsonPermission.SIDE_BAR_ELIGIBLE_ORDERS_GENERATE_COMMISSIONS,
      children: []
    }]
  }, {
    id: '15.1',
    name: _JsonPermission.SIDE_BAR_PAYOUTS,
    children: [{
      id: '15.1.0',
      name: _JsonPermission.SIDE_BAR_PAYOUTS_PAY_INVOICES,
      children: []
    }, {
      id: '15.1.1',
      name: _JsonPermission.SIDE_BAR_PAYOUTS_VIEW_DETAILS,
      children: [{
        id: '15.1.1.0',
        name: _JsonPermission.SIDE_BAR_PAYOUTS_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE,
        children: []
      }, {
        id: '15.1.1.1',
        name: _JsonPermission.SIDE_BAR_PAYOUTS_VIEW_DETAILS_DOWNLOAD_AS_EXCEL,
        children: []
      }, {
        id: '15.1.1.2',
        name: _JsonPermission.SIDE_BAR_PAYOUTS_VIEW_DETAILS_DOWNLOAD_AS_PDF,
        children: []
      }]
    }]
  }, {
    id: '15.2',
    name: _JsonPermission.SIDE_BAR_WAREHOUSE_REMITTANCE,
    children: [{
      id: '15.2.0',
      name: _JsonPermission.SIDE_BAR_WAREHOUSE_REMITTANCE_PAY_INVOICES,
      children: []
    }, {
      id: '15.2.1',
      name: _JsonPermission.SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS,
      children: [{
        id: '15.2.1.0',
        name: _JsonPermission.SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE,
        children: []
      }, {
        id: '15.2.1.1',
        name: _JsonPermission.SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS_DOWNLOAD_AS_EXCEL,
        children: []
      }, {
        id: '15.2.1.2',
        name: _JsonPermission.SIDE_BAR_WAREHOUSE_REMITTANCE_VIEW_DETAILS_DOWNLOAD_AS_PDF,
        children: []
      }]
    }]
  }, {
    id: '15.3',
    name: _JsonPermission.SIDE_BAR_WAREHOUSE_EXPENSES,
    children: [{
      id: '15.3.0',
      name: _JsonPermission.SIDE_BAR_WAREHOUSE_EXPENSES_PAY_INVOICES,
      children: []
    }, {
      id: '15.3.1',
      name: _JsonPermission.SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS,
      children: [{
        id: '15.3.1.0',
        name: _JsonPermission.SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE,
        children: []
      }, {
        id: '15.3.1.1',
        name: _JsonPermission.SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS_DOWNLOAD_AS_EXCEL,
        children: []
      }, {
        id: '15.3.1.2',
        name: _JsonPermission.SIDE_BAR_WAREHOUSE_EXPENSES_VIEW_DETAILS_DOWNLOAD_AS_PDF,
        children: []
      }]
    }]
  }, {
    id: '15.4',
    name: _JsonPermission.SIDE_BAR_ADVERTISER_COMMISSIONS,
    children: [{
      id: '15.4.0',
      name: _JsonPermission.SIDE_BAR_ADVERTISER_COMMISSIONS_PAY_INVOICES,
      children: []
    }, {
      id: '15.4.1',
      name: _JsonPermission.SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS,
      children: [{
        id: '15.4.1.0',
        name: _JsonPermission.SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS_DELETE_ORDER_FROM_INVOICE,
        children: []
      }, {
        id: '15.4.1.1',
        name: _JsonPermission.SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS_DOWNLOAD_AS_EXCEL,
        children: []
      }, {
        id: '15.4.1.2',
        name: _JsonPermission.SIDE_BAR_ADVERTISER_COMMISSIONS_VIEW_DETAILS_DOWNLOAD_AS_PDF,
        children: []
      }]
    }]
  }, {
    id: '15.5',
    name: _JsonPermission.SIDE_BAR_REFERRALS,
    children: [{
      id: '15.5.0',
      name: _JsonPermission.SIDE_BAR_REFERRALS_GENERATE,
      children: []
    }]
  }]
}, {
  id: '16',
  name: _JsonPermission.SIDE_BAR_ACCOUNTING,
  children: [{
    id: '16.0',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING,
    children: []
  }, {
    id: '16.1',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_CHART,
    children: []
  }, {
    id: '16.2',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_AFFILIATE,
    children: []
  }, {
    id: '16.3',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_REFERRER,
    children: []
  }, {
    id: '16.4',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_SALE_PAGE,
    children: []
  }, {
    id: '16.5',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_OFFER,
    children: []
  }, {
    id: '16.6',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_COUNTRY,
    children: []
  }, {
    id: '16.7',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_WAREHOUSE,
    children: []
  }, {
    id: '16.8',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_MANAGER,
    children: []
  }, {
    id: '16.9',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_PRODUCT,
    children: []
  }, {
    id: '16.10',
    name: _JsonPermission.SIDE_BAR_ACCOUNTING_VIEW_STATS_BY_CALL_AGENT,
    children: []
  }]
}, {
  id: '17',
  name: _JsonPermission.SIDE_BAR_NOTIFICATIONS,
  children: [{
    id: '17.0',
    name: _JsonPermission.SIDE_BAR_NOTIFICATIONS_CREATE,
    children: []
  }]
}, {
  id: '18',
  name: _JsonPermission.SIDE_BAR_TUTORIALS,
  children: [{
    id: '18.0',
    name: _JsonPermission.SIDE_BAR_TUTORIALS_CREATE_TUTORIAL,
    children: [{
      id: '18.0.0',
      name: _JsonPermission.SIDE_BAR_TUTORIALS_CREATE_TUTORIAL_CATEGORY,
      children: []
    }]
  }, {
    id: '18.1',
    name: _JsonPermission.SIDE_BAR_TUTORIALS_EDIT_TUTORIAL,
    children: [{
      id: '18.1.0',
      name: _JsonPermission.SIDE_BAR_TUTORIALS_CREATE_TUTORIAL_CATEGORY,
      children: []
    }]
  }, {
    id: '18.2',
    name: _JsonPermission.SIDE_BAR_TUTORIALS_DELETE_TUTORIAL,
    children: []
  }, {
    id: '18.3',
    name: _JsonPermission.SIDE_BAR_TUTORIALS_TOGGLE_PUBLISH_TUTORIAL_CATEGORY,
    children: []
  }, {
    id: '18.4',
    name: _JsonPermission.SIDE_BAR_TUTORIALS_EDIT_TUTORIAL_CATEGORY,
    children: []
  }, {
    id: '18.5',
    name: _JsonPermission.SIDE_BAR_TUTORIALS_DELETE_TUTORIAL_CATEGORY,
    children: []
  }]
}, {
  id: '19',
  name: _JsonPermission.SIDE_BAR_SUPPORT,
  children: [{
    id: '19.0',
    name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS,
    children: [{
      id: '19.0.0',
      name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_CREATE_FAQ,
      children: [{
        id: '19.0.0.0',
        name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_CREATE_FAQ_CREATE_CATEGORY,
        children: []
      }]
    }, {
      id: '19.0.1',
      name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_EDIT_FAQ,
      children: [{
        id: '19.0.1.0',
        name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_EDIT_FAQ_CREATE_CATEGORY,
        children: []
      }]
    }, {
      id: '19.0.2',
      name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_DELETE_FAQ,
      children: []
    }, {
      id: '19.0.3',
      name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_DELETE_FAQ_CATEGORY,
      children: []
    }, {
      id: '19.0.4',
      name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_EDIT_FAQ_CATEGORY,
      children: []
    }, {
      id: '19.0.5',
      name: _JsonPermission.SIDE_BAR_SUPPORT_FAQS_TOGGLE_FAQ_CATEGORY,
      children: []
    }]
  }, {
    id: '19.1',
    name: _JsonPermission.SIDE_BAR_SUPPORT_TICKETS,
    children: [{
      id: '19.1.0',
      name: _JsonPermission.SIDE_BAR_SUPPORT_TICKETS_CREATE_TICKET,
      children: []
    }, {
      id: '19.1.1',
      name: _JsonPermission.SIDE_BAR_SUPPORT_TICKETS_CREATE_TICKET_MESSAGE,
      children: []
    }]
  }]
}, {
  id: '20',
  name: _JsonPermission.SIDE_BAR_NETWORK_SDK_ACCOUNTS,
  children: [{
    id: '20.0',
    name: _JsonPermission.SIDE_BAR_NETWORK_SDK_ACCOUNTS_CREATE,
    children: []
  }]
}, {
  id: '21',
  name: _JsonPermission.SIDE_BAR_WAREHOUSES,
  children: [{
    id: '21.0',
    name: _JsonPermission.SIDE_BAR_WAREHOUSES_CREATE_WAREHOUSE,
    children: []
  }, {
    id: '21.1',
    name: _JsonPermission.SIDE_BAR_WAREHOUSES_EDIT_WAREHOUSE,
    children: []
  }, {
    id: '21.2',
    name: _JsonPermission.SIDE_BAR_WAREHOUSES_MULTIPLE_WAREHOUSE_ACTIVATION,
    children: []
  }]
}, {
  id: '22',
  name: _JsonPermission.SIDE_BAR_CALL_CENTER,
  children: [{
    id: '22.0',
    name: _JsonPermission.SIDE_BAR_CALL_CENTER_CREATE_CALL_CENTER,
    children: []
  }, {
    id: '22.1',
    name: _JsonPermission.SIDE_BAR_CALL_CENTER_EDIT_CALL_CENTER,
    children: []
  }, {
    id: '22.2',
    name: _JsonPermission.SIDE_BAR_CALL_CENTER_MULTIPLE_CALL_CENTER_ACTIVATION,
    children: []
  }]
}, {
  id: '23',
  name: _JsonPermission.SIDE_BAR_ADVERTISER,
  children: [{
    id: '23.0',
    name: _JsonPermission.SIDE_BAR_ADVERTISER_CREATE_ADVERTISER,
    children: []
  }, {
    id: '23.1',
    name: _JsonPermission.SIDE_BAR_ADVERTISER_EDIT_ADVERTISER,
    children: []
  }, {
    id: '23.2',
    name: _JsonPermission.SIDE_BAR_ADVERTISER_MULTIPLE_ADVERTISER_ACTIVATION,
    children: []
  }]
}, {
  id: '24',
  name: _JsonPermission.SIDE_BAR_AFFILIATES,
  children: [{
    id: '24.0',
    name: _JsonPermission.SIDE_BAR_AFFILIATES_MULTIPLE_AFFILIATE_ACTIVATION,
    children: []
  }, {
    id: '24.1',
    name: _JsonPermission.SIDE_BAR_AFFILIATES_MULTIPLE_AFFILIATE_MANAGER_ASSIGNMENT,
    children: []
  }]
}, {
  id: '25',
  name: _JsonPermission.SIDE_BAR_REFERRALS_PROGRAM,
  children: []
}, {
  id: '26',
  name: _JsonPermission.SIDE_BAR_USERS,
  children: [{
    id: '26.0',
    name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS,
    children: [{
      id: '26.0.0',
      name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS,
      children: [{
        id: '26.0.0.0',
        name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_CREATE_USER,
        children: []
      }, {
        id: '26.0.0.1',
        name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_EDIT_USER,
        children: []
      }, {
        id: '26.0.0.2',
        name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_MULTIPLE_STATUS_CHANGE,
        children: []
      }, {
        id: '26.0.0.3',
        name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_USERS_DUPLICATE_USER,
        children: []
      }]
    }, {
      id: '26.0.1',
      name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_ROLES,
      children: [{
        id: '26.0.1.0',
        name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_ROLES_UPDATE_ROLES,
        children: []
      }, {
        id: '26.0.1.1',
        name: _JsonPermission.SIDE_BAR_USERS_ACCOUNTS_MANAGE_ROLES_UPDATE_USERS,
        children: []
      }]
    }]
  }, {
    id: '26.1',
    name: _JsonPermission.SIDE_BAR_USERS_IDENTITY_VERIFICATION,
    children: [{
      id: '26.1.0',
      name: _JsonPermission.SIDE_BAR_USERS_IDENTITY_VERIFICATION_ADD_IDENTITY_VERIFICATION,
      children: []
    }]
  }]
}, {
  id: '27',
  name: _JsonPermission.SIDE_BAR_LIBRARY,
  children: []
}, {
  id: _JsonPermission.PERMISSIONS.ACTIVITY_LOGS.ID,
  name: _JsonPermission.SIDE_BAR_ACTIVITY_LOGS,
  children: []
}]);
_defineProperty(JsonPermission, "id_attribute_name", 'id');
_defineProperty(JsonPermission, "name_attribute_name", 'name');
_defineProperty(JsonPermission, "children_attribute_name", 'children');